<template>
  <div class="basic-setting-content pl16 pr16">
    <el-form-item label="商品图片：" class="labelStyle" :rules="[{ required: true, message: '请上传商品图片' }]"
                  prop="model.image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.model.image">
          <transition-group>
            <div v-for="(item, index) in form.model.image.slice(0,7)" :key="'item_'+index">
              <div class="item" v-if="item.filePath">
                <el-image style="width: 100%;height: 100%" :src="item.filePath" :preview-src-list="[item.filePath]"/>
                <a v-if="item.filePath" href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i
                  class="el-icon-close"></i></a>
              </div>
              <div class="item img-select" style="flex-direction: column" v-if="!item.filePath"
                   @click="openProductUpload('image', 'image',index)">
                <i class="el-icon-plus"></i>
                <div style="font-size: 12px">{{ index === 0 ? '上传主图' : '上传辅图' }}</div>
              </div>
            </div>
          </transition-group>
        </draggable>

      </div>
    </el-form-item>
    <el-row :gutter="80" type="flex" justify="left">
      <el-col :span="1.5">
        <el-form-item label="商品视频：" class="labelStyle">
          <el-row>
            <div class="draggable-list">
              <div class="item img-select" v-if="form.model.videoId==0" @click="openProductUpload('video', 'video')"><i
                class="el-icon-plus"></i></div>
              <div v-if="form.model.videoId!=0">
                <video class="item" :src="form.model.videoFilePath" :autoplay="false" controls>
                  您的浏览器不支持 video 标签
                </video>
                <div>
                  <el-button icon="el-icon-picture-outline" @click="delVideo">删除视频</el-button>
                </div>
              </div>
            </div>
          </el-row>
        </el-form-item>
      </el-col>
      <el-col :span="1.5">
        <el-form-item label="视频封面：" class="labelStyle">
          <el-row>
            <div class="draggable-list">
              <div class="item img-select" v-if="form.model.posterId==0" @click="openProductUpload('image', 'poster')">
                <i class="el-icon-plus"></i>
              </div>
              <div v-if="form.model.posterId!=0" class="item">
                <el-image :src="form.model.posterFilePath" style="width: 100%;height: 100%"
                          :preview-src-list="[form.model.posterFilePath]"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deletePostImg"><i
                  class="el-icon-close"></i></a>
              </div>
            </div>
          </el-row>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="已选分类：" class="labelStyle" :rules="[{ required: true, message: '你选择商品分类' }]"
                  prop="model.categoryIds">
      <!--      <template v-slot:label>-->
      <!--        <span>已选分类：</span>-->
      <!--        <el-tag class="m-r-10"-->
      <!--                :key="tag.categoryId"-->
      <!--                v-for="tag in getShowCategoryList"-->
      <!--                closable-->
      <!--                :disable-transitions="false"-->
      <!--                @close="handleClose(tag)">-->
      <!--          {{ tag.name }}-->
      <!--        </el-tag>-->
      <!--      </template>-->
      <!--      <el-cascader-panel-->
      <!--        ref="typeCascader"-->
      <!--        class="cascader-panel"-->
      <!--        v-model="form.model.categoryIds"-->
      <!--        :props="{ label: 'name', value: 'categoryId', children: 'children', checkStrictly: false,multiple:true,emitPath:false}"-->
      <!--        expand-trigger="click"-->
      <!--        @change="handleTypeChange"-->
      <!--        :options="getOptionList" style="width: 850px">-->
      <!--      </el-cascader-panel>-->

      <el-cascader
        style="width: 850px"
        v-model="form.model.categoryIds"
        :options="getOptionList"
        filterable
        placeholder=" "
        :props="{ label: 'name', value: 'categoryId', children: 'children', checkStrictly: false,multiple:true,emitPath:false}"
        clearable></el-cascader>

      <!--      <div-->
      <!--        style="display: flex;flex-direction: row;align-items: flex-start;justify-content: flex-start;margin-top: 10px">-->
      <!--        <span style="flex-shrink: 1">已选择：</span>-->
      <!--        <div>-->
      <!--          <p v-for="(item,index) in getShowCategoryList" :key="index">-->
      <!--            {{ item }}-->
      <!--          </p>-->
      <!--        </div>-->
      <!--      </div>-->


      <!--      <el-select v-model="form.model.categoryIds" multiple style="width: 460px">-->
      <!--        <template v-for="cat in form.category">-->
      <!--          <el-option :value="cat.categoryId" :key="cat.categoryId" :label="cat.name" disabled></el-option>-->
      <!--          <template v-for="two in cat.children">-->
      <!--            <el-option :value="two.categoryId" :key="two.categoryId" :label="two.name"-->
      <!--                       style="padding-left: 30px;"></el-option>-->
      <!--          </template>-->
      <!--        </template>-->
      <!--      </el-select>-->
    </el-form-item>
    <!--    基本信息-->
    <!--    <div class="common-form" style="font-size: 20px">基本信息</div>-->
    <el-row :gutter="40" style="max-width: 890px">
      <el-col :span="24">
        <el-form-item label="导购标题：" class="labelStyle" :rules="[{ required: true, message: '请填写导购标题' }]"
                      prop="model.productName">
          <el-input v-model="form.model.productName" style="max-width: 850px"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="40" style="max-width: 890px">
      <el-col :span="6">
        <el-form-item label="品牌名称：" class="labelStyle" :rules="[{ required: true, message: '你填写品牌名称' }]"
                      prop="model.productBrand">
          <el-input v-model="form.model.productBrand" style="width: 100%"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="商品编码：" class="labelStyle">
          <el-input v-model="form.model.productNo" style="width: 100%"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="生产企业：" class="labelStyle">
          <el-input v-model="form.model.manufacturer" style="width: 100%"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="40" style="max-width: 890px">
      <el-col :span="6">
        <el-form-item label="商品剂型：" class="labelStyle">
          <el-select v-model="form.model.formulation" filterable>
            <el-option v-for="(item,index) in formulationList" :value="item" :label="item" :key="index"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="18">
        <el-form-item label="商品卖点：" class="labelStyle">
          <!--      <el-input type="textarea" v-model="form.model.sellingPoint" style="max-width: 850px"></el-input>-->
          <el-select v-model="form.model.sellingPoint" multiple filterable allow-create default-first-option
                     style="width: 100%"></el-select>
          <div class="gray9">输入"***"卖点后回车，进行下一个卖点输入，推荐卖点4个</div>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="40" style="max-width: 890px">
      <el-col :span="6">
        <el-form-item label="农药登记证号：" class="labelStyle">
          <el-input v-model="form.model.pesticideNo" style="width: 100%"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="40" style="max-width: 890px">
      <el-col :span="8">
        <el-form-item label="销售状态：" class="labelStyle">
          <el-radio-group v-model="form.model.productStatus">
            <el-radio :label="10">立即上架</el-radio>
            <el-radio :label="20">放入仓库</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="8" style="display: none">
        <el-form-item class="labelStyle" label="配送方式：">
          <el-radio-group v-model="form.model.deliveryType">
            <el-radio v-for="(item,index) in all_type" :label="item.value" :key="index">{{ item.name }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!--        <el-form-item label="商品属性：" class="labelStyle">-->
        <!--          <el-radio-group v-model="form.model.isPresell">-->
        <!--            <el-radio :label="0">现售商品</el-radio>-->
        <!--            <el-radio :label="1">预售商品</el-radio>-->
        <!--          </el-radio-group>-->
        <!--        </el-form-item>-->
      </el-col>
    </el-row>
    <!--    <el-row :gutter="40" style="max-width: 890px" v-if="form.model.isPresell==1">-->
    <!--      <el-col :span="12">-->
    <!--        <el-form-item class="labelStyle" label="预售起止时间："-->
    <!--                      :rules="[{ required: true, message: '设置预售起止时间' }]"-->
    <!--                      prop="model.presellStartTime">-->
    <!--          <div class="block">-->
    <!--            <span class="demonstration"></span>-->
    <!--            <el-date-picker-->
    <!--              size="small"-->
    <!--              v-model="presellTime"-->
    <!--              type="datetimerange"-->
    <!--              value-format="yyyy-MM-dd hh:mm:ss"-->
    <!--              range-separator="至"-->
    <!--              start-placeholder="开始时间"-->
    <!--              end-placeholder="结束时间"-->
    <!--            ></el-date-picker>-->
    <!--          </div>-->
    <!--        </el-form-item>-->
    <!--      </el-col>-->
    <!--      <el-col :span="12">-->
    <!--        <el-form-item class="labelStyle" label="预计到货时间："-->
    <!--                      :rules="[{ required: true, message: '设置预计到货时间' }]"-->
    <!--                      prop="model.arrivalTime">-->
    <!--          <div class="d-s-c">-->
    <!--            <el-input-number v-model="form.model.arrivalTime" @change="handleArrivalTimeChange" :min="1"-->
    <!--                             label=""></el-input-number>-->
    <!--            <span class="ml10">天</span>-->
    <!--          </div>-->
    <!--        </el-form-item>-->
    <!--      </el-col>-->
    <!--    </el-row>-->
    <!--其他设置-->
    <!--    <div class="common-form mt50" style="font-size: 20px">其他设置</div>-->
    <el-row :gutter="40" style="max-width: 890px">
      <!--      <el-col :span="12">-->
      <!--        <el-form-item label="最低限购数量：" class="labelStyle" :rules="[{ required: true, message: ' ' }]"-->
      <!--                      prop="model.minLimit">-->
      <!--          <el-input type="number" min="1" v-model="form.model.minLimit" class="w-full"></el-input>-->
      <!--          <div class="gray9">商品每次最低购买数量</div>-->
      <!--        </el-form-item>-->
      <!--      </el-col>-->
      <el-col :span="12">
        <el-form-item label="最高限购数量：" class="labelStyle" :rules="[{ required: true, message: ' ' }]"
                      prop="model.limitNum">
          <el-input type="number" min="0" v-model="form.model.limitNum" class="w-full"></el-input>
          <div class="gray9">每个会员购买的最大数量，0为不限购</div>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="会员等级限制：" class="labelStyle">
          <el-select v-model="form.model.gradeIds" multiple placeholder="请选择" class="w-full">
            <el-option
              v-for="item in form.gradeList"
              :key="item.gradeId"
              :label="item.name"
              :value="item.gradeId">
            </el-option>
          </el-select>
          <div class="gray9">仅设置的等级会员可购买，不设置则都可以购买</div>
        </el-form-item>
      </el-col>
    </el-row>
    <!--    <el-row :gutter="40" style="max-width: 890px">-->
    <!--      <el-col :span="12">-->
    <!--        <el-form-item class="labelStyle" label="运费模板：" :rules="[{ required: true, message: '选择运费模板' }]"-->
    <!--                      prop="model.deliveryId"-->
    <!--                      v-if="form.model.isVirtual==0">-->
    <!--          <el-select v-model="form.model.deliveryId" style="width: 100%">-->
    <!--            <el-option v-for="item in form.delivery" :value="item.deliveryId" :key="item.deliveryId"-->
    <!--                       :label="item.name"></el-option>-->
    <!--          </el-select>-->
    <!--        </el-form-item>-->
    <!--      </el-col>-->

    <!--    </el-row>-->
    <!--    <el-row :gutter="40" style="max-width: 890px">-->
    <!--      <el-col :span="12">-->
    <!--        <el-form-item label="会员等级限制：" class="labelStyle">-->
    <!--          <el-select v-model="form.model.gradeIds" multiple placeholder="请选择" class="w-full">-->
    <!--            <el-option-->
    <!--              v-for="item in form.gradeList"-->
    <!--              :key="item.gradeId"-->
    <!--              :label="item.name"-->
    <!--              :value="item.gradeId">-->
    <!--            </el-option>-->
    <!--          </el-select>-->
    <!--          <div class="gray9">仅设置的等级会员可购买，不设置则都可以购买</div>-->
    <!--        </el-form-item>-->
    <!--      </el-col>-->
    <!--    </el-row>-->

    <el-form-item label="发货类型：" v-if="form.model.isVirtual==1">
      <el-radio-group v-model="form.model.virtualAuto">
        <el-radio :label="1">自动</el-radio>
        <el-radio :label="0">手动</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="虚拟内容：" :rules="[{ required: true, message: '请填写虚拟内容' }]" prop="model.virtualContent"
                  v-if="form.model.isVirtual==1">
      <el-input type="text" v-model="form.model.virtualContent" class="max-w460"></el-input>
      <div class="gray9">虚拟物品内容</div>
    </el-form-item>
    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">
      上传图片
    </Upload>
  </div>
</template>

<script>

import Upload from '@/components/file/Upload'
import draggable from 'vuedraggable'

export default {
  components: {
    Upload,
    draggable
  },
  data () {
    return {
      isProductUpload: false,
      config: {},
      file_name: 'image',
      formulationList: ['可湿性粉剂', '悬浮剂', '乳油', '水乳剂', '种衣剂', '微乳剂', '粉剂', '颗粒剂', '水剂', '浓乳油', '水分散粒剂', '烟剂', '缓释剂', '油剂', '片剂'
        , '乳化剂', '分散剂', '熏蒸剂', '胶悬剂'],
      all_type: [{
        name: '快递',
        value: 10
      }, {
        name: '自提',
        value: 20
      }],
      selIndex: 0
    }
  },
  inject: ['form'],
  created () {

  },
  computed: {
    getOptionList () {
      let resultList = []
      let supplierCategory = this.form.supplierCategory
      if (supplierCategory) {
        let category = this.form.category
        if (category && category.length) {
          let list = category.filter(res => {
            return res.supplierCategoryId === supplierCategory.categoryId
          })
          if (list && list.length) {
            supplierCategory.children = list
          }
        }
        resultList.push(supplierCategory)
      }
      return resultList
    },
    getShowCategoryList () {
      let list = []
      let supplierCategory = this.form.supplierCategory
      if (supplierCategory) {
        let category = this.form.category
        let clist = category.filter(res => {
          return res.supplierCategoryId === supplierCategory.categoryId
        })
        let selIds = this.form.model.categoryIds
        if (selIds && selIds.length) {
          for (let i = 0; i < selIds.length; i++) {
            if (clist && clist.length) {
              let proResultList = []
              this.findPath(clist, selIds[i], proResultList)
              if (proResultList && proResultList.length) {
                let info = proResultList[0]
                list.push(info)
              }
            }

            // let resultList = [supplierCategory.name]
            // let proResultList = []
            // if (clist && clist.length) {
            //   this.findPath(clist, selIds[i], proResultList)
            // }
            // proResultList = proResultList.reverse()
            // list.push(resultList.concat(proResultList).join(' > '))
          }
        }
      }
      return list
    },
    presellTime: {
      get () {
        return [this.form.model.presellStartTime || '', this.form.model.presellEndTime || '']
      },
      set (e) {
        if (e && e.length > 1) {
          this.form.model.presellStartTime = e[0] || ''
          this.form.model.presellEndTime = e[1] || ''
        } else {
          this.form.model.presellStartTime = ''
          this.form.model.presellEndTime = ''
        }

      }
    }
  },
  methods: {
    findPath (list, id, resultList) {
      let hasInLine = false
      if (list && list.length) {
        for (let i = 0; i < list.length; i++) {
          let res = list[i]
          if (res.categoryId === id) {
            resultList.push(res)
            hasInLine = true
            break
          } else if (res.children && res.children.length) {
            let result = this.findPath(res.children, id, resultList)
            hasInLine = result
            if (result) {
              // resultList.push(res.name)
              break
            }
          }
        }
      }
      return hasInLine
    },
    handleArrivalTimeChange (e) {
      console.log('handleArrivalTimeChange = ' + e)
      if (e === undefined) {
        this.$nextTick(() => {
          this.form.model.arrivalTime = 1
        })
      }
    },

    handleTypeChange (selectedOptions) {                 //产品类型变化时校验
      console.log('selectedOptions:', selectedOptions)

      // this.selectedTypePath = this.findPath(this.typeIdPathArray, this.productTypeOptions).join('  >  ')
    },

    /*打开上传图片*/
    openProductUpload: function (file_type, file_name, index) {
      this.file_name = file_name
      if (file_type === 'image') {
        this.selIndex = index || 0
        this.config = {
          total: 1,
          fileType: 'image'
        }
      } else {
        this.config = {
          total: 1,
          fileType: 'video'
        }
      }
      this.isProductUpload = true
    },

    /*上传商品图片*/
    returnProductImgsFunc (e) {
      if (e != null) {
        if (this.file_name === 'video') {
          this.form.model.videoId = e[0].fileId
          this.form.model.videoFilePath = e[0].filePath
        } else if (this.file_name === 'image') {
          let index = this.selIndex
          this.form.model.image[index].imageId = e[0].fileId
          this.form.model.image[index].filePath = e[0].filePath
          let imgs = this.form.model.image
          // 兼容后端
          for (let i = 0; i < imgs.length; i++) {
            if (typeof (imgs[i].imageId) == 'undefined') {
              this.$set(imgs[i], 'imageId', imgs[i].fileId)
            }
          }
          this.$set(this.form.model, 'image', imgs)
        } else if (this.file_name === 'poster') {
          this.form.model.posterId = e[0].fileId
          this.form.model.posterFilePath = e[0].filePath
        }
      }
      this.isProductUpload = false
    },
    handleClose (tag) {
      let self = this
      let index = this.form.model.categoryIds.indexOf(tag.categoryId)
      if (index !== -1) {
        this.form.model.categoryIds.splice(index, 1)
        let categoryIds = Object.assign([], this.form.model.categoryIds)
        this.$refs.typeCascader.clearCheckedNodes()
        this.$nextTick(() => {
          self.$set(self.form.model, 'categoryIds', categoryIds)
        })

      }
    },
    /*删除商品图片*/
    deleteImg (index) {
      this.form.model.image[index].filePath = ''
    },
    deletePostImg () {
      this.form.model.posterId = 0
      this.form.model.posterFilePath = ''
    },
    delVideo () {
      this.form.model.videoId = 0
      this.form.model.video = {}
    },
  }
}
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>

<style lang="css" scoped>
.labelStyle >>> .el-form-item__label {
  font-size: 16px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/part/Basic.vue